import { defineStore } from 'pinia';

function findId(issueId, data) {
  return data.flatMap(group => group.issues).find(issue => issue.id === issueId);
}

export const useIssuesStore = defineStore({
  id: 'IssuesStore',
  state: () => ({
    componentKey: 0,
    issues: [],
    loading: true,
    loadingNotification: false,
  }),
  getters: {
    getIssueById: (state) => {
      if (state?.issues[0]?.issues) {
        return (issueId) => findId(issueId, state.issues);
      } else if (state?.issues?.shaft_element_set || state?.issues?.non_shaft_element_set_issues) {
        return (issueId) => {
          return findId(issueId, state.issues.shaft_element_set) || findId(issueId, state.issues.non_shaft_element_set_issues);
        };
      }
      return (issueId) => state.issues.find((issue) => issue.id === issueId);
    },
  },
  actions: {
    /**
     * Sets loading and loadingNotification to false
     */
    setLoadingToFalse() {
      this.loading = false;
      this.loadingNotification = false;
    },

    /**
     * Update an issue
     *  @param {object} updatedIssue - the new issue data
     */
    updateIssue(updatedIssue) {
      const issueToUpdate = this.getIssueById(updatedIssue.id);

      if (issueToUpdate) {
        Object.assign(issueToUpdate, updatedIssue);
      }

      this.componentKey = this.componentKey + 1;
    },

    /**
     * Remove an issue image
     * @param {string} issueId - the current issue
     * @param {string} imageId - the image id
     */
    deleteImage(issueId, imageId) {
      const issueToUpdate = this.getIssueById(issueId);

      if (issueToUpdate) {
        issueToUpdate.issue_images.splice(
          issueToUpdate.issue_images.findIndex((image) => {
            return image.id === imageId;
          }),
          1
        );
      }
    },
  },
});
